"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IsUndefinedValidator {
    isValid(input) {
        return typeof input === "undefined";
    }
}
exports.IsUndefinedValidator = IsUndefinedValidator;
//# sourceMappingURL=IsUndefinedValidator.js.map